import { render } from "./unauthorized.vue?vue&type=template&id=036bb6bb&scoped=true"
import script from "./unauthorized.vue?vue&type=script&lang=js"
export * from "./unauthorized.vue?vue&type=script&lang=js"

import "./unauthorized.vue?vue&type=style&index=0&id=036bb6bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036bb6bb"]])

export default __exports__